import { useEffect, useState, useCallback } from 'react';
import ResumeQuantity from "../components/resumeQuantity";
import { fetchActiveUsers, fetchExpiredUsers, fetchAgreementsUsers, fetchAllUsers, fetchUsersCounts } from '../apis/usersApi';
import UserList from '../components/userList';
import { openNotification } from '../components/notifications';

const Users = () => {
  const [showUsers, setShowUsers] = useState("all");
  const [usersData, setUsersData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({ page: 1, limit: 50 });
  const [counts, setCounts] = useState({ active: NaN, expired: NaN, all: NaN, agreements: NaN });
  const [showCollapse, setShowCollapse] = useState(false);

  const fetchCounts = useCallback(async () => {
    const data = await fetchUsersCounts();
    setCounts(prev => ({ 
        ...prev, 
        active: data.active, 
        expired: data.expired,
        all: data.all,
        agreements: data.agreements
    }));
  }, []);

  const loadData = useCallback(async () => {
    setLoading(true);
    let result = { items: [], total: 0 };
    switch (showUsers) {
      case "all":
        result = await fetchAllUsers(tableParams);
        break;
      case "active":
        result = await fetchActiveUsers(tableParams);
        break;
      case "expired":
        result = await fetchExpiredUsers(tableParams);
        break;
      case "agreements":
        const response = await fetchAgreementsUsers(tableParams);
        if(!response.success) {
            openNotification("error", "Error al cargar los usuarios de convenios", response.error?.message || "Inténtalo más tarde");
        } else {
            result = response.data;
        }
        break;
      default:
        break;
    }
    setUsersData(result);
    setLoading(false);
  }, [showUsers, tableParams]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const changeShowedUsers = (users_type) => {
    setShowUsers(users_type);
    setTableParams({ page: 1, limit: 50 });
  };

  const onTableChange = (newParams) => {
    setTableParams(prev => ({ ...prev, ...newParams }));
  };

  let usersContent;
  const commonProps = {
    users: usersData.items,
    total: usersData.total,
    loading: loading,
    currentPage: tableParams.page,
    pageSize: tableParams.limit,
    onTableChange: onTableChange,
    showExpirationDate: true,
    showRemainingClasses: true
  };

  switch (showUsers) {
    case "all":
      usersContent = (
        <>
          <h3 className='text-center'>Todos los Usuarios</h3>
          <UserList {...commonProps} />
        </>
      );
      break;
    case "active":
      usersContent = (
        <>
          <h3 className='text-center'>Usuarios Activos</h3>
          <UserList {...commonProps} />
        </>
      );
      break;
    case "expired":
      usersContent = (
        <>
          <h3 className='text-center'>Usuarios Vencidos</h3>
          <UserList {...commonProps} />
        </>
      );
      break;
    case "agreements":
      usersContent = (
        <>
          <h3 className='text-center'>Usuarios Convenios</h3>
          <UserList {...commonProps} />
        </>
      );
      break;
    default:
      usersContent = null;
  }

  return (
    <>
      <div className="col-11 mx-auto shadow-lg p-3 mb-5 bg-body rounded">
        <div className='d-flex justify-content-around'>
        <ResumeQuantity title="Active" onClick={() => changeShowedUsers("active")} amount={counts.active} percentageChange="0" period={30} icon="subscribe.png" backgroundColor="bc-gp-secondary-light" />
        <ResumeQuantity title="Expired" onClick={() => changeShowedUsers("expired")} amount={counts.expired} percentageChange="0" period={30} icon="subscribe.png" backgroundColor="bc-gp-secondary-light" />
        </div>
        <div className='d-flex flex-column w-100'>
          <button
            className="btn btn-link m-auto"
            onClick={() => setShowCollapse((prev) => !prev)}
            style={{ textDecoration: 'none' }}
          >
            {showCollapse ? '▲' : '▼'}
          </button>
          {showCollapse && (
            <div className="d-flex justify-content-around">
              <ResumeQuantity
                title="Todos"
                amount={counts.all}
                onClick={() => changeShowedUsers("all")}
                percentageChange="0"
                period={30}
                icon="subscribe.png"
                backgroundColor="bc-gp-secondary-light"
              />
              <ResumeQuantity
                title="Convenios"
                amount={counts.agreements}
                onClick={() => changeShowedUsers("agreements")}
                percentageChange="0"
                period={30}
                icon="subscribe.png"
                backgroundColor="bc-gp-secondary-light"
              />
            </div>
          )}
        </div>
      </div>

      {usersContent}
    </>
  );
};

export default Users;
